<template>
  <div>
        <ctop />
        <cswiper />
        <search />
        <div class="c_content">
            <div class="crumbs">
                <div class="border"></div>
                <div class="now">当前位置：</div>
                <div class="one">案例展示</div>
                <div class="fu">＞</div>
                <div class="one">案例列表</div>
            </div>
            
            <div class="q_content">
                <div class="content_l">
                    <div class="top">

                        <div class="list" v-for="(vo,i) of caselist" :key="i" @click="gotocontent(vo.id)">
                            <div class="list_content">
                            <img class="zhu" :src="$uploadurl + vo.img">
                            <div class="name">{{vo.name}}</div>
                            <div class="tag">
                                <div class="t_list" v-for="(v,i) of JSON.parse(vo.tag)" :key="i">{{v}}</div>
                                <!-- <div class="t_list">品牌</div> -->
                            </div>
                            <div class="state">
                                <div class="option">
                                    <img src="~@/assets/play_num.png">
                                    <span>{{vo.click_num}}</span>
                                </div>
                                <div class="option">
                                    <img src="~@/assets/collect.png">
                                    <span>{{vo.collect_num}}</span>
                                </div>
                                <div class="option">
                                    <img src="~@/assets/zan_ash.png">
                                    <span>{{vo.peck_num}}</span>
                                </div>
                            </div>
                            </div>
                        </div>

                        
                    </div>
                    
                    <div class="bottom">
                        <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page.sync="currentPage3"
                        :page-size="24"
                        layout="prev, pager, next, jumper"
                        :total="100">
                        </el-pagination>
                    </div>
                </div>

                <div class="content_r">
                    <div class="top_title">热门推荐</div>
                    <div class="r_list">

                        <div class="list" v-for="(vo,i) of caselist.slice(0,5)" :key="i" @click="gotocontent(vo.id)">
                            <img class="left" :src="$uploadurl + vo.img">
                            <div class="right">
                            <div class="name">{{vo.name}}</div>
                            <div class="des">{{vo.des}}</div>
                            <div class="bottom">

                                <div class="state">
                                    <div class="option">
                                        <img src="~@/assets/play_num.png">
                                        <span>{{vo.click_num}}</span>
                                    </div>
                                    <div class="option">
                                        <img src="~@/assets/collect.png">
                                        <span>{{vo.collect_num}}</span>
                                    </div>
                                    <div class="option">
                                        <img src="~@/assets/zan_ash.png">
                                        <span>{{vo.peck_num}}</span>
                                    </div>
                                </div>
                                
                            </div>
                            </div>
                        </div>

                        

                        
                    </div>
                </div>

            </div>
        </div>


        <bottom />
        <right />
  </div>
</template>

<script>
import ctop from '@/components/ctop'
import cswiper from '@/components/cswiper'
import search from '@/components/search'
import bottom from '@/components/bottom'
import right from '@/components/right'
export default {
  name: 'Home',
  components: {
      cswiper,
      ctop,
      search,
      bottom,
    right
  },
  data () {
    return {
       currentPage3: 5,
       caselist:[]
    }
  },
  computed: {
    
  },
  mounted() {
    this.getcase()
  },
  methods:{
        gotocontent(id){
            this.$router.push('/case_content?url=category&id=' + id);
        },
        getcase(){
            this.$http.post('/api/casecontent/index',this.$qs.stringify({id:0})).then((res)=>{
                let callback = res.data
                if(callback.code == 200){
                    this.caselist = callback.data
                    // console.log(this.caselist)
                }else{
                    
                }
            }).catch((error) => {
                console.log('获取失败')
            })
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
        },

  },
  
}
</script>

<style lang="scss" scoped>
$zycolor:#CF2C2E;

.c_content{
    width: 100%;
    padding:0 75px;
    box-sizing: border-box;
}
.crumbs{
    display: flex;
    border-bottom: 1px solid #eee;
    padding: 15px 0;
    align-items: center;
    .border{
        height: 20px;
        width: 5px;
        background: #CF2C2E;
        border-radius: 5px;
        margin:0 20px 0 65px;
    }
    .fu{
        margin:0 5px;
    }
}
.q_content{
    display: flex;
    justify-content: space-between;
    margin-top:80px;
    .content_l{
        width: 70%;
        // padding:20px 0;
        margin-bottom: 100px;
        .top{
            display: flex;
            flex-wrap:wrap;
        }
        .bottom{
            display: flex;
            justify-content: center;
            margin-top:20px;
        }
        .list:hover{
            .list_content{
                
                animation:1s infinite mymove;
                animation-iteration-count:1;
                animation-fill-mode: forwards;
            }
        }
        @keyframes mymove
        {
            from {box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.16);}
            to {box-shadow: 1px 6px 9px rgba(0, 0, 0, 0.16);}
        }
        .list{
            
            box-sizing: border-box;
            border-radius: 15px;
            // margin-right:20px;
            // flex: 1;
            flex-basis:25%;
            padding:0 15px;
            cursor: pointer;
            .list_content{
                border: 1px solid #e2e2e2;
                border-radius: 15px;
                margin-bottom: 20px;
            }
            .zhu{
                width: 100%;
                height: 250px;
            }
            .name{
                width: 100%;
                text-align: left;
                margin:7px 0 7px 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                -webkit-box-orient: vertical;
            }
            .tag{
                margin:5px 0;
                display: flex;
                color: #A1A1A1;
                font-size: 14px;
                margin-left: 10px;
                height: 20px;
                .t_list{
                    margin-right:10px;
                }
            }
            .state{
				display: flex;
				// margin-top:10px;
				padding:10px 0px 10px 0;
				margin-left: 10px;
				.option{
					display: flex;
					align-items: center;
					margin-right:10px;
					img{
						width: 20px;
						height: 20px;
					}
					span{
						color:#A1A1A1;
						font-size: 14px;
					}
				}
			}
        }
    }
    .content_r{
        width: 30%;
        border-radius: 15px;
        border:1px solid #eee;
        .top_title{
            margin-top:20px;
            font-size: 24px;
        }
        .r_list{
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top:20px;
            padding:0 20px;
            .list{
                display: flex;
                cursor: pointer;
                border-radius: 15px;
                margin-bottom: 20px;
                width: 100%;
                .left{
                    width: 190px;
                    height: 190px;
                }
            }
            .list:hover{
                animation:1s infinite mymove;
                animation-iteration-count:1;
                animation-fill-mode: forwards;
            }
            .right{
                padding:10px;
                display: flex;
                justify-content: space-between;
                flex-direction: column;
                width: 57%;
                .name{
                    text-align: left;
                    font-size: 18px;
                    font-weight: bold;
                }
                .des{
                    color:#A1A1A1;
                    text-align: left;
                    font-size: 14px;
                    margin-top:5px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }
            }
            .bottom{
                display: flex;
                .state{
                    display: flex;
                    // margin-top:10px;
                    padding:10px 0px 10px 0;
                    
                    .option{
                        display: flex;
                        align-items: center;
                        margin-right:10px;
                        img{
                            width: 20px;
                            height: 20px;
                        }
                        span{
                            color:#A1A1A1;
                            font-size: 14px;
                        }
                    }
                }
            }
        }
    }
}

</style>
<style land='scss'>
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    color:#A1A1A1;
}
.el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #D05C5C;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
    color:#D05C5C
}
.el-pager li{
    height: 35px;
    line-height: 35px;
    width: 35px;
}
.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
    height: 35px;
    line-height: 35px;
    width: 35px;
}
</style>